module.exports = __webpack_public_path__ + "img/acuerdoCapte05.b337371f.jpg";